import {theme} from "./Tema";

export const TIPODOCSREQ = ['Pdf', 'Imagen']

export const ESTADOSCOLECCIONES = [
    {
        nombre: 'Pulicada',
        color: '#796254'
    },
    {
        nombre: 'Archivada',
        color: '#808080'
    },
]

export const ESTADOSPRENDA = [
    {
        nombre: 'Pulicado',
        color: '#796254'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#5500d1'
    },
    {
        nombre: 'Admin',
        color: '#000000'
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]


export const ESTADOCUENTA = [
    {
        nombre: 'Aceptado',
        color: '#5500d1'
    },
    {
        nombre: 'Suspendido',
        color: '#000000'
    },
]


export const ESTADOSEVENTO = [
    {
        nombre: 'Publicado',
        color: '#5500d1'
    },
    {
        nombre: 'Archivado',
        color: '#000000'
    },

]

export const ESTADOSSOPORTE = [
    {
        nombre: 'Nuevo',
        color: '#796254'
    },
    {
        nombre: 'Cerrado',
        color: '#808080'
    },
    {
        nombre: 'Abierto',
        color: '#808080'
    },
]


export const TIPOSCONTENIDO = ['Video', 'Pdf', 'Imagen']

export const RANGOSCUENTA = ['Consultor', 'Distribuidor']
